import React from 'react';
import { Users } from 'lucide-react';

const StepParentInfo = ({ formData, onChange }) => (
  <div className="form-step">
    <h3><Users size={20} /> Parent/Guardian Information</h3>

    <div className="form-row">
      <div className="form-group">
        <label>First Name *</label>
        <input type="text" name="parent_first_name" value={formData.parent_first_name} onChange={onChange} placeholder="Parent's first name" />
      </div>
      <div className="form-group">
        <label>Last Name *</label>
        <input type="text" name="parent_last_name" value={formData.parent_last_name} onChange={onChange} placeholder="Parent's last name" />
      </div>
    </div>

    <div className="form-row">
      <div className="form-group">
        <label>Email *</label>
        <input type="email" name="email" value={formData.email} onChange={onChange} placeholder="email@example.com" />
      </div>
      <div className="form-group">
        <label>Phone *</label>
        <input type="tel" name="phone" value={formData.phone} onChange={onChange} placeholder="(410) 555-0123" />
      </div>
    </div>

    <div className="form-group">
      <label>Street Address *</label>
      <input type="text" name="address" value={formData.address} onChange={onChange} placeholder="123 Main Street" />
    </div>

    <div className="form-row">
      <div className="form-group">
        <label>City *</label>
        <input type="text" name="city" value={formData.city} onChange={onChange} placeholder="Randallstown" />
      </div>
      <div className="form-group small">
        <label>State *</label>
        <select name="state" value={formData.state} onChange={onChange}>
          <option value="MD">MD</option>
          <option value="DC">DC</option>
          <option value="VA">VA</option>
          <option value="PA">PA</option>
        </select>
      </div>
      <div className="form-group small">
        <label>Zip Code *</label>
        <input type="text" name="zip_code" value={formData.zip_code} onChange={onChange} placeholder="21133" />
      </div>
    </div>
  </div>
);

export default StepParentInfo;
